import { render, staticRenderFns } from "./EditArticleSell.vue?vue&type=template&id=72705d9e"
import script from "./EditArticleSell.vue?vue&type=script&lang=js"
export * from "./EditArticleSell.vue?vue&type=script&lang=js"
import style0 from "./EditArticleSell.vue?vue&type=style&index=0&id=72705d9e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports